import { toast, ToastOptions } from 'react-toastify';

const options = {
  position: 'bottom-right',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
} as ToastOptions;

// Toast Notifications helper object;
// Adjust if customization needed;
export const notifications = {
  success(text: string) {
    toast.success(text, options);
  },
  warning(text: string) {
    toast.warn(text, options);
  },
  error(text: string) {
    toast.error(text, options);
  },
  info(text: string) {
    toast.info(text, options);
  },
  dark(text: string) {
    toast.dark(text, options);
  },
  customInfo(text: string, autoClose: number) {
    toast.info(text, { ...options, autoClose });
  },
  /**
   * An info toast that takes the user somewhere when clicked. It is given longer than the usual four
   * seconds, because a toast the user is meant to act on has to outlive the glance that notices it.
   */
  infoAction(text: string, onClick: () => void) {
    toast.info(text, { ...options, autoClose: 10000, onClick, style: { cursor: 'pointer' } });
  }
};
